import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StoreReportCustomFieldsMapped } from '../../models/job-report';
import { AttachmentService } from '../../../../utilities/attachment/attachment.service';
import { FileUploaderService } from '../../../../utilities/file-uploader/file-uploader.service';
import { ParsedFile } from '../../../../utilities/file-uploader/file-uploader.component';

import * as _ from 'lodash';
import { FileUploadTarget } from '../../../../utilities/file-uploader/file-upload-target';
import { ModuleManagerService } from '../../../services/module/module-manager.service';
import { ModuleKeyDefinition } from '../../../../constants/module.constant';

export class FieldAttachmentDocumentParsedAnswer {
  attachment_id: string;
  name: string;

  constructor(attachmentId: string, name: string) {
    this.attachment_id = attachmentId;
    this.name = name;
  }
}

@Component({
  selector: 'tn-field-attachment-document',
  templateUrl: './field-attachment-document.component.html',
  styleUrls: ['./field-attachment-document.component.scss']
})
export class FieldAttachmentDocumentComponent implements OnInit {

  @Input() field: StoreReportCustomFieldsMapped;
  @Input() isInput: boolean = false;

  @Output() onFieldUpdate: EventEmitter<StoreReportCustomFieldsMapped> = new EventEmitter<StoreReportCustomFieldsMapped>(null);

  answers: FieldAttachmentDocumentParsedAnswer[] = [];

  fileInputs: ParsedFile[];

  constructor(
    private _attachmentService: AttachmentService,
    private _fileUploaderService: FileUploaderService,
    private _moduleManagerService: ModuleManagerService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.field.answer.value) {
      try {
        this.answers = JSON.parse(this.field.answer.value);
        this.answers.sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
      } catch (err) {
        this.answers = [];
      };
    }
  }

  openAttachment(ans: FieldAttachmentDocumentParsedAnswer): void {
    const isAllowAttachmentSave = this._moduleManagerService.checkIfModuleExists(ModuleKeyDefinition.ATTACHMENT_SAVE) || this._moduleManagerService.checkIfModuleExists(ModuleKeyDefinition.ATTACHMENT_SAVE_WEB);
    
    this._attachmentService.prepareAttachmentModalContentByFileId(
      [ans.attachment_id], null, null, null, null, !isAllowAttachmentSave
    );
  }

  openFileUploader() {
    this._fileUploaderService.openFileUploaderModal(
      FileUploadTarget.DOCUMENT,
      (files: ParsedFile[]) => {
        this.fileInputs = files;
        this.onChange();
      },
      _.map(this.fileInputs, 'file'),
      true
    );
  }

  removeAttachment(file) {
    this.fileInputs = _.without(this.fileInputs, file);
    this.onChange();
  }

  getAnswerValue(): any {
    return _.map(this.fileInputs, 'file');
  }

  onChange() {
    this.field.answer.value = this.getAnswerValue();
    this.field.answer.files = this.getAnswerValue();
    this.onFieldUpdate.emit(this.field);
  }

}
